<template>
  <ValidationObserver ref="form">
    <b-form class="form--auth"
            @submit.prevent
            v-stream:submit="onSubmit$"
    >
      <transition name="slide-left" mode="out-in">
        <div v-if="success"
             :key="'success'"
             class="reset-password__frag reset-password--success"
        >
          <img src="../../assets/img/success.svg" alt="成功提交申請">
          <h3>成功設定密碼</h3>
          <p>如需更改密碼，請於登入後到“帳戶設定”更改。</p>
          <b-button to="/login" variant="primary" size="lg">立即登入</b-button>
        </div>
        <div v-else
             :key="'form'"
             class="reset-password__frag"
        >
          <h3>設定登入密碼</h3>
          <AGCInput v-model="password"
                    vid="password"
                    name="密碼"
                    type="password"
                    rules="required|password"
                    class="mb-3"
                    placeholder="密碼"
                    required
          >
            <template v-slot:invalidFeedback="{ errors }">
              <span
                style="font-size: 80%;"
                :style="{ color: errors[0] ? '#dc3545' : '#7e8b97' }"
              >
                密碼最少8個字，必須包含數字及大，小寫英文字母（不支援特殊符號）。
              </span>
            </template>
          </AGCInput>
          <AGCInput v-model="confirmPassword"
                    name="確認密碼"
                    type="password"
                    rules="required|confirmed:password"
                    class="mb-3"
                    placeholder="確認密碼"
                    required
          ></AGCInput>
          <b-button type="submit"
                    variant="primary"
                    size="lg"
                    :disabled="loading"
                    block
          >
            確認
          </b-button>
        </div>
      </transition>
      <div v-if="loading" class="form__overlay">
        <LoadingSpinner></LoadingSpinner>
      </div>
    </b-form>
  </ValidationObserver>
</template>

<script>
import { switchMap, tap } from 'rxjs/operators';
import { BButton, BForm } from 'bootstrap-vue';
import { getErrorMsg } from '@/helpers/error-msg';
import http from '../../helpers/http';
import toastSettings from '../../helpers/toast-settings';
import formMixin from '../../mixins/form';
import LoadingSpinner from '../../components/LoadingSpinner.vue';
import AGCInput from '../../components/form/AGCInput.vue';

export default {
  mixins: [formMixin],
  components: {
    BForm,
    BButton,
    LoadingSpinner,
    AGCInput,
  },
  data: () => ({
    password: null,
    confirmPassword: null,
    loading: false,
    success: false,
  }),
  computed: {
    token() {
      return this.$route.query.token;
    },
  },
  domStreams: ['onSubmit$'],
  subscriptions() {
    return {
      submit: this.onSubmit$
        .pipe(
          switchMap(this.validate),
          tap(() => {
            this.loading = true;
          }),
          switchMap(() => http({
            method: 'POST',
            url: '/agc-merchant-api/auth/resetPassword',
            data: {
              password: this.password,
              token: this.token,
            },
          }, {
            next: () => {
              this.success = true;
            },
            error: ({ data: { msg } }) => {
              this.$bvToast.toast(getErrorMsg(msg), {
                ...toastSettings,
                title: '錯誤',
                toaster: 'b-toaster-top-center',
              });
            },
            complete: () => {
              this.loading = false;
            },
          })),
        ),
    };
  },
  mounted() {
    this.$emit('updated');
  },
};
</script>

<style lang="scss">
@import "../../assets/scss/transition/slide";
@import "../../assets/scss/form--auth";
</style>

<style scoped lang="scss">
.reset-password {
  &__frag {
    transition: all 0.2s cubic-bezier(0.55, 0, 0.1, 1);
  }

  &--success {
    text-align: center;

    & img {
      margin-bottom: 1rem;
    }
  }
}
</style>
